import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKompaniaIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18.098,
	height: 30.018,
	viewBox: "0 0 18.098 30.018",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_4770",
		"data-name": "Group 4770",
		transform: "translate(-379 174.158)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_7613",
				"data-name": "Path 7613",
				d: "M47.125,41.162c-1.347-.018-2.695-.049-4.042-.052a2.514,2.514,0,0,1-2.7-1.708,3.1,3.1,0,0,1,.789-3.234c3.512-3.714,6.988-7.469,10.483-11.2,1.187-1.268,2.8-1.346,3.76-.2a2.959,2.959,0,0,1-.284,4.189q-2.961,3.171-5.93,6.333c-.182.195-.349.406-.563.657,1.553.021,3.012.037,4.472.062,1.076.018,1.621.822,2.408,1.778.727.882.136,2.256-.679,3.079-1.1,1.112-2.216,2.206-3.484,3.465,1.295,1.395,2.422,2.6,3.54,3.817,1.506,1.638,1.176,3.876-.689,4.722a2.285,2.285,0,0,1-2.74-.681q-2.615-2.928-5.212-5.877a2.844,2.844,0,0,1,.031-3.953c.3-.342.636-.65.956-.973l-.12-.218",
				transform: "translate(339.994 -197.387)",
				fill: "#dfdfde"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_7614",
				"data-name": "Path 7614",
				d: "M183.731,412.661l7.9-8.047a.671.671,0,0,1,.961,0l2.758,2.809a.7.7,0,0,1,0,.978l-7.9,8.047a.67.67,0,0,1-.961,0l-2.758-2.809a.7.7,0,0,1,0-.979",
				transform: "translate(201.037 -566.299)",
				fill: "#fff"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_7615",
				"data-name": "Path 7615",
				d: "M395.586,815.716a2.608,2.608,0,0,1,3.223-1.843,2.669,2.669,0,0,1,1.81,3.282A2.608,2.608,0,0,1,397.4,819a2.669,2.669,0,0,1-1.81-3.282",
				transform: "translate(-4.488 -963.238)",
				fill: "#fff"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_7616",
				"data-name": "Path 7616",
				d: "M17.9,3.987,3.915,18.234a.659.659,0,0,1-.944,0L.2,15.409a.689.689,0,0,1,0-.962L14.184.2a.659.659,0,0,1,.944,0L17.9,3.025a.689.689,0,0,1,0,.962",
				transform: "translate(378.999 -174.157)",
				fill: "#fff"
			})
		]
	})
});
export { SvgKompaniaIcon as ReactComponent };
